import React from 'react';
import { BiFilterAlt, BiX } from 'react-icons/bi';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';

const BlogFilter = ({
    categories,
    years,
    selectedCategory,
    selectedYear,
    onCategoryChange,
    onYearChange,
    onReset
}) => {
    const { t } = useTranslations();

    const hasActiveFilters = selectedCategory !== 'all' || selectedYear !== 'all';

    return (
        <section className="blog-filter">
            <div className="container">
                <FadeInAnimation direction="up" delay={50}>
                    <div className="blog-filter-container">
                        <div className="blog-filter-controls">
                            <div className="blog-filter-label">
                                <BiFilterAlt />
                                <span>{t('blog_filter_label')}</span>
                            </div>

                            {/* Category Filter */}
                            <div className="blog-filter-select-wrapper">
                                <select
                                    value={selectedCategory}
                                    onChange={(e) => onCategoryChange(e.target.value)}
                                    className={`blog-filter-select ${selectedCategory !== 'all' ? 'active' : 'inactive'}`}
                                >
                                    <option value="all">{t('blog_filter_all_categories')}</option>
                                    {categories.map((category) => (
                                        <option key={category} value={category}>
                                            {category}
                                        </option>
                                    ))}
                                </select>
                                <div className={`blog-filter-select-arrow ${selectedCategory !== 'all' ? 'active' : 'inactive'}`}>
                                    ▼
                                </div>
                            </div>

                            {/* Year Filter */}
                            <div className="blog-filter-select-wrapper">
                                <select
                                    value={selectedYear}
                                    onChange={(e) => onYearChange(e.target.value)}
                                    className={`blog-filter-select ${selectedYear !== 'all' ? 'active' : 'inactive'}`}
                                    style={{ minWidth: '140px' }}
                                >
                                    <option value="all">{t('blog_filter_all_years')}</option>
                                    {years.map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </select>
                                <div className={`blog-filter-select-arrow ${selectedYear !== 'all' ? 'active' : 'inactive'}`}>
                                    ▼
                                </div>
                            </div>

                            {/* Reset Button */}
                            {hasActiveFilters && (
                                <button onClick={onReset} className="blog-filter-reset">
                                    <BiX />
                                    {t('blog_filter_reset')}
                                </button>
                            )}
                        </div>
                    </div>
                </FadeInAnimation>
            </div>
        </section>
    );
};

export default BlogFilter;
